new MutationObserver(() => {
  const body = document.body;

  if (!body.classList.contains('smart-cart--enabled')) return;
  if (body.classList.contains('rebuy-cart-visible')) return;
  if (
    !body.classList.contains('modal-showing') &&
    !body.classList.contains('modal-show')
  ) {
    return;
  }

  if (
    document.querySelector(
      [
        'drawer-component[open]',
        'modal-component[open]',
        'basic-modal[open]',
        'menu-drawer[open]',
        'search-drawer[open]',
        'quick-view-modal[open]',
        'cart-addon-modal[open]',
      ].join(',')
    )
  ) {
    return;
  }

  body.classList.remove('modal-showing', 'modal-show');
  document.querySelector('cart-drawer[open]')?.removeAttribute('open');
}).observe(document.body, { attributes: true, attributeFilter: ['class'] });

(() => {
  const REBUY_CART_EVENTS = [
    'rebuy:cart.add',
    'rebuy:cart.change',
    'rebuy:cart.remove',
    'rebuy:cart.update',
    'rebuy:cart.refresh',
  ];

  const handleRebuyEvent = () => {
    fetch(`${FoxTheme.routes.cart_url}`, { ...FoxTheme.utils.fetchConfig('json', 'GET') })
      .then((response) => response.json())
      .then((cart) => {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart });
      })
      .catch((error) => {
        console.error('[rebuy-cart-bridge] Error fetching cart:', error);
      });
  };

  REBUY_CART_EVENTS.forEach((eventName) => {
    document.addEventListener(eventName, handleRebuyEvent);
  });
})();
